// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.close-container {
    position: absolute;
    top: 0.5rem;
    right: 0.5rem;
    fill: var(--default-text-color);
    line-height: 0;
}`, "",{"version":3,"sources":["webpack://./src/CloseButton.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,WAAW;IACX,aAAa;IACb,+BAA+B;IAC/B,cAAc;AAClB","sourcesContent":[".close-container {\n    position: absolute;\n    top: 0.5rem;\n    right: 0.5rem;\n    fill: var(--default-text-color);\n    line-height: 0;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
